<template>
  <div class="page-container">
    <!-- 搜索栏 -->
    <div>
      <div>

        <div class="page-card__header">
          <el-row>
            <el-col :span="6">
              <span style="padding-right: 20px"> 小程序用户（共{{ aSum }}人）</span>
            </el-col>
            <el-col :span="6">
              <el-input v-model="keyword">
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="serach"
                ></el-button>
              </el-input>
            </el-col>
          </el-row>
        </div>


      </div>

      <!-- 数据表格 -->
      <el-table :data="tableData" style="width: 100%; padding: 0 20px">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>

        <el-table-column prop="avatarurl" label="头像" width="80">
          <template slot-scope="scope">
            <el-image
              :src="productImg + scope.row.avatarurl"
              style="width: 30px"
            >
              <div slot="error">
                <i class="el-icon-picture-outline" style="font-size: 30px"></i>
              </div>
            </el-image>
          </template>
        </el-table-column>

        <el-table-column prop="openid" label="OpenID"></el-table-column>
        <el-table-column prop="name" label="姓名" width="180"></el-table-column>
        <el-table-column prop="phone_number" label="手机号" width="180"></el-table-column>
        <el-table-column prop="auth_page" label="授权页面" width="180">
        </el-table-column>
        <el-table-column prop="sharer" label="推荐人" width="180">
        </el-table-column>
        <el-table-column prop="last_login_time" label="最后登录时间" width="180">
        </el-table-column>
        <el-table-column prop="create_time" label="注册时间" width="180">
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" class="action-btn--danger" @click="handleClick(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页器 -->
      <div class="pagination-wrap">
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="pagesize"
          :total="aSum"
          :page-count="pageCount"
          :current-page.sync="currentPage"
          background
          layout="prev, pager, next,jumper"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import api from "../../utils/api";

  export default {
    data() {
      return {
        keyword: '',
        tableData: [],
        //分页
        // 总条目数 total
        aSum: 0,
        // 当前页数 currenr_page
        currentPage: 1,
        // 总页数 num_pages
        pageCount: 1,
        // 每页显示条目数 pagesize
        pagesize: 10,
        productImg:
          "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/avatar/",
      };
    },
    mounted() {
      this.getInfo();
    },

    methods: {
      /** 获取小程序用户列表数据 */
      getInfo() {
        let url = this.baseUrl + "/admin/wxusers/?ordering=-create_time";
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = 1;
        });
      },

      /** 分页切换处理 */
      handleCurrentChange(val) {
        let url = this.baseUrl + "/admin/wxusers/?ordering=-create_time&page=" + val+'&search='+this.keyword;
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = val;
        });
      },

      /** 按关键词搜索小程序用户 */
      serach() {
        let url = this.baseUrl + "/admin/wxusers/?ordering=-create_time&search=" + this.keyword+'&page=1';
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = 1;
        });
      },

      /** 删除小程序用户 */
      handleClick(row) {
        this.$confirm("将删除此条信息，是否继续", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let id = row.id;
          let url = this.baseUrl + "/admin/wxusers/" + id + "/";
          api.deleteData(url).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getInfo();
          });
        });
      },
    },
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/wxUser.vue